const MagnifyingGlass = ({ width = 24, height = 24, color = '#000000' }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <circle
      cx="9.14"
      cy="9.14"
      r="7.64"
      style={{
        fill: 'none',
        stroke: color,
        strokeMiterlimit: 10,
        strokeWidth: 1.91,
      }}
    />
    <line
      x1="22.5"
      y1="22.5"
      x2="14.39"
      y2="14.39"
      style={{
        fill: 'none',
        stroke: color,
        strokeMiterlimit: 10,
        strokeWidth: 1.91,
      }}
    />
  </svg>
);

export default MagnifyingGlass;
